var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.rate.doctor
    ? _c("div", [
        _vm._v("\n  " + _vm._s(_setup.tStatic("Лечащий врач")) + ":\n  "),
        _c(
          "a",
          {
            staticClass: "ui-text primary--text",
            attrs: { href: _setup.doctorUrl, title: _setup.doctorName },
          },
          [_vm._v("\n    " + _vm._s(_setup.doctorName) + "\n  ")]
        ),
        _vm._v(" "),
        _setup.specialityName
          ? _c(
              "div",
              { staticClass: "d-flex text-body-2 text--text gc-1 mt-1" },
              [
                _c("span", [
                  _vm._v(_vm._s(_setup.tStatic("Специальность")) + ":"),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_setup.specialityName))]),
              ]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }